(() => {
  'use strict';
  if (window.BuceGreenUI) return;
  const rails = new WeakSet();
  const stocks = new WeakSet();
  const badgeSelector = '.t4s-single-product-badge .t4s-badge-sale, .t4s-product-badge .t4s-badge-sale, [data-buce-discount-badge]';
  function cleanFinderArtifacts(scope) {
    const roots = [];
    if (scope === document) roots.push(...document.querySelectorAll('#t4s-search-hidden'));
    else if (scope instanceof Element) {
      if (scope.matches('#t4s-search-hidden')) roots.push(scope);
      roots.push(...scope.querySelectorAll('#t4s-search-hidden'));
    }
    roots.forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const remove = [];
      while (walker.nextNode()) {
        const value = (walker.currentNode.nodeValue || '').trim();
        if (value === '\\n') remove.push(walker.currentNode);
      }
      remove.forEach(node => node.remove());
    });
  }
  function paintBadge(badge) {
    const match = badge.textContent.match(/(\d+(?:[.,]\d+)?)\s*%/);
    if (!match) { badge.removeAttribute('data-buce-green-tier'); return; }
    const percent = Number(match[1].replace(',', '.'));
    if (!Number.isFinite(percent) || percent < 0 || percent > 100) return;
    const tier = percent >= 50 ? 'extreme' : percent >= 30 ? 'strong' : 'soft';
    if (badge.dataset.buceGreenTier !== tier) badge.dataset.buceGreenTier = tier;
  }
  function paintRail(rail) {
    rail.querySelectorAll('.t4s-badge-sale,[data-buce-discount-badge]').forEach(paintBadge);
    if (rails.has(rail)) return;
    rails.add(rail);
    new MutationObserver(() => rail.querySelectorAll('.t4s-badge-sale,[data-buce-discount-badge]').forEach(paintBadge))
      .observe(rail, {childList:true, subtree:true, characterData:true});
  }
  function mirrorStock(root) {
    const host = root.closest('[data-product-featured]') || root.closest('.shopify-section');
    const rail = host?.querySelector('.t4s-single-product-badge');
    if (!rail) return;
    let chip = rail.querySelector('[data-buce-pdp-stock]');
    const message = root.querySelector('[data-buce-stock-message]');
    let copy = root.hidden ? '' : (message?.textContent || '').trim();
    if (root.dataset.stockNudge) copy = copy.replace(root.dataset.stockNudge, '').trim().replace(/\.$/, '');
    if (!chip && !copy) return;
    if (!chip) {
      chip = document.createElement('span');
      chip.className = 't4s-badge-item buce-pdp-stock';
      chip.setAttribute('data-buce-pdp-stock', '');
      rail.append(chip);
    }
    if (chip.textContent !== copy) chip.textContent = copy;
    chip.hidden = !copy;
  }
  function bindStock(root) {
    mirrorStock(root);
    if (stocks.has(root)) return;
    stocks.add(root);
    new MutationObserver(() => mirrorStock(root))
      .observe(root, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['hidden']});
  }
  function scan(scope) {
    if (!(scope instanceof Element) && scope !== document) return;
    cleanFinderArtifacts(scope);
    if (scope instanceof Element && scope.matches(badgeSelector)) paintBadge(scope);
    scope.querySelectorAll(badgeSelector).forEach(paintBadge);
    if (scope instanceof Element && scope.matches('.t4s-single-product-badge,.t4s-product-badge')) paintRail(scope);
    scope.querySelectorAll('.t4s-single-product-badge,.t4s-product-badge').forEach(paintRail);
    if (scope instanceof Element && scope.matches('[data-buce-smart-stock]')) bindStock(scope);
    scope.querySelectorAll('[data-buce-smart-stock]').forEach(bindStock);
    if (scope instanceof Element && (scope.matches('.t4s-single-product-badge') || scope.querySelector('.t4s-single-product-badge'))) {
      const host = scope.closest('[data-product-featured]') || scope.closest('.shopify-section');
      host?.querySelectorAll('[data-buce-smart-stock]').forEach(mirrorStock);
    }
  }
  function bindGalleryScroll() {
    const config = document.querySelector('[data-buce-gallery-close]');
    const label = key => config?.dataset[key] || '';
    const dialog = document.createElement('dialog');
    dialog.className = 'buce-photo-dialog';
    dialog.setAttribute('aria-label', label('buceGalleryTitle'));
    const toolbar = document.createElement('div');
    toolbar.className = 'buce-photo-toolbar';
    const stage = document.createElement('div');
    stage.className = 'buce-photo-stage';
    const image = document.createElement('img');
    stage.append(image);
    const counter = document.createElement('span');
    counter.setAttribute('aria-live', 'polite');
    const button = (text, fn) => {
      const el = document.createElement('button');
      el.type = 'button';
      el.textContent = text;
      el.addEventListener('click', fn);
      toolbar.append(el);
      return el;
    };
    let photos = [], index = 0, saved = null;
    const previous = button('←', () => show(index - 1));
    previous.setAttribute('aria-label', label('buceGalleryPrevious'));
    toolbar.append(counter);
    const next = button('→', () => show(index + 1));
    next.setAttribute('aria-label', label('buceGalleryNext'));
    const zoom = button(label('buceGalleryZoom'), () => {
      stage.classList.toggle('is-zoomed');
      zoom.setAttribute('aria-pressed', String(stage.classList.contains('is-zoomed')));
    });
    zoom.setAttribute('aria-pressed', 'false');
    const exit = button(label('buceGalleryClose'), () => dialog.close());
    exit.className = 'buce-photo-close';
    dialog.append(toolbar, stage);
    document.body.append(dialog);
    function show(value) {
      index = (value + photos.length) % photos.length;
      image.src = photos[index].src;
      image.alt = photos[index].alt;
      stage.classList.remove('is-zoomed');
      stage.scrollTop = stage.scrollLeft = 0;
      zoom.setAttribute('aria-pressed', 'false');
      counter.textContent = (index + 1) + ' / ' + photos.length;
      previous.disabled = next.disabled = photos.length < 2;
    }
    const restore = () => {
      if (!saved) return;
      const before = saved;
      saved = null;
      document.body.style.position = before.position;
      document.body.style.top = before.top;
      document.body.style.width = before.width;
      document.documentElement.classList.remove('buce-photo-locked');
      window.scrollTo({top: before.y, behavior: 'instant'});
      if (before.focus instanceof HTMLElement && before.focus.isConnected) before.focus.focus({preventScroll:true});
      image.removeAttribute('src');
    };
    dialog.addEventListener('close', restore);
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
    });
    stage.addEventListener('dblclick', event => { event.preventDefault(); zoom.click(); });
    const selector = '[data-t4s-gallery--open],[data-pr-trigger-pswp],[data-pswp-btn-triger],[data-t4s-image-opend]';
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest(selector);
      if (!trigger || dialog.open || typeof dialog.showModal !== 'function') return;
      let source;
      if (trigger.hasAttribute('data-t4s-image-opend')) {
        source = [{src:trigger.dataset.pswpSrc, alt:trigger.textContent.trim()}];
      } else {
        const host = trigger.closest('[data-product-featured],.t4s-product,.shopify-section') || document;
        const nodes = [...host.querySelectorAll('[data-t4s-gallery--open]')].filter(node => !node.closest('.is--media-hide'));
        source = nodes.map(node => {
          const img = node.querySelector('img[data-master],img:not(.t4s-img-noscript)');
          return {node,src:img?.dataset.master || img?.currentSrc || img?.src,alt:img?.alt || ''};
        }).filter(item => item.src);
      }
      if (!source?.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      photos = source;
      const active = source.findIndex(item => item.node === trigger || item.node?.closest('.is-selected'));
      const body = document.body;
      saved = {y:window.scrollY,position:body.style.position,top:body.style.top,width:body.style.width,focus:document.activeElement};
      body.style.position = 'fixed';
      body.style.top = -saved.y + 'px';
      body.style.width = '100%';
      document.documentElement.classList.add('buce-photo-locked');
      show(active < 0 ? 0 : active);
      try { dialog.showModal(); exit.focus({preventScroll:true}); }
      catch { restore(); }
    }, true);
  }
  function start() {
    bindGalleryScroll();
    scan(document);
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) {
        if (!(node instanceof Element) || node.matches('[data-buce-pdp-stock]')) continue;
        scan(node);
      }
    }).observe(main, {childList:true, subtree:true});
  }
  window.BuceGreenUI = Object.freeze({version:'20261004.green-final-1', refresh:() => scan(document)});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();

